import { css } from 'styled-components';

export const linkStyle = (color: string) => css`
  text-decoration: underline;
  text-decoration-color: ${color};
  text-underline-offset: 2px;
  text-decoration-thickness: 1px;

  &:hover,
  &:active,
  &:focus {
    text-decoration-color: ${color};
  }
`;
